import { ThemedButton } from "@/Button";
import { withValidate } from "@/withValidate";
import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
interface option {
  id: string;
  title: string;
  desc: string;
  price: string;
  max?: number;
}
interface ServiceCardProps {
  defaultValues?: string[];
  options: option[];
  className?: string;
  col?: number;
  onChange?: (value: string) => unknown;
  max?: number;
  editable?: boolean;
}

const ServiceCard = ({
  options,
  className,
  col = 3,
  defaultValues = [],
  onChange,
  max,
  editable = true,
}: ServiceCardProps) => {
  const [values, setValues] = useState(defaultValues);
  const [isInitialized, setIsInitialized] = useState(false);

  // defaultValues가 변경될 때 내부 state 업데이트 (초기 로드 시에만)
  useEffect(() => {
    if (defaultValues.length > 0 && !isInitialized) {
      setValues(defaultValues);
      setIsInitialized(true);
    }
  }, [defaultValues, isInitialized]);

  const handleChange = (data: string) => {
    // onChange?.bind(null, option.value)
    // const target = e.target;
    // if (target instanceof HTMLElement) {
    //   const value = target.dataset.value;
    //   if (!value) return;
    //   // if (max && values.length >= max) {
    //   //   if (values.includes(value)) {
    //   //     setValues(values.filter((v) => v !== value));
    //   //   } else {
    //   //     return;
    //   //   }
    console.log(editable);
    if (editable) {
      if (values.includes(data)) {
        setValues(values.filter((v) => v !== data));
      } else {
        console.log("111111111");
        const exValues = [...values];
        if (max && values.length >= max) exValues.shift();
        setValues([...exValues, data]);
      }
    }
  };
  useEffect(() => {
    if (editable) {
      onChange?.(values.join(","));
    }
  }, [onChange, values]);

  return (
    <div
      className={twMerge("grid gap-1", className)}
      style={{
        gridTemplateColumns: `repeat(${col}, minmax(0, 1fr))`,
      }}
    >
      {options.map((option) => (
        <ThemedButton
          type="button"
          color={values?.includes(option.id) ? "secondary" : "quaternary"}
          size="xl"
          className={`
          flex flex-col items-center justify-between w-30 h-36 px-2 py-3 rounded-xl border
          ${values?.includes(option.id) ? "border-orange-400 text-orange-400 bg-white" : "border-gray-200 text-gray-700 bg-white"}
          transition gap-0
          `}
          onClick={() => handleChange(option.id)}
        >
          <div className="flex flex-col flex-1 gap-1 items-center">
            <div className="h-12 text-base font-bold leading-tight text-center whitespace-pre-line">
              {option.title}
            </div>
            <div className="text-xs text-center text-gray-500 whitespace-pre-line">
              {option.desc}
            </div>
          </div>
          <div
            className={`
              mt-4 font-bold rounded-full px-4 py-1 text-sm
              ${
                values?.includes(option.id)
                  ? "bg-orange-50 text-orange-400"
                  : "bg-gray-100 text-gray-400"
              }
              `}
          >
            {option.price} 원
          </div>
        </ThemedButton>
      ))}
    </div>
  );
};
export const ValidateServiceCard = withValidate(ServiceCard);
